import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { MatDialog, MatTabChangeEvent } from "@angular/material";
import { GroupService } from "../shared/services/group/group.service";
import { WidgetService } from "../shared/services/widget/widget.service";
import { DashboardService } from "../shared/services/dashboard/dashboard.service";
import { UserService } from "../shared/services/user/user.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import "rxjs/add/operator/debounceTime";
import { PlaylistService } from '../shared/services/playlist/playlist.service';
import { CommonService } from '../shared/services/common/common.service';
import { ResizeEvent } from "angular2-resizable";
import { SiteService } from '../shared/services/site/site.service';
import { ZoneService } from '../shared/services/zone/zone.service';
import { BrandService } from '../shared/services/brand/brand.service';
import { ExportDashboardViewerDialog } from "../shared/export/dashboardexport/dashboard-export-dialog.component";
import { ScheduleDashboardViewerDialog } from "../shared/export/dashboardschedule/dashboard-schedule-dialog.component";
import { ExportGroupViewerDialog } from "../shared/export/groupexport/group-export-dialog.component";
import { PdfViewerDialog } from "../shared/export/pdfviewer/pdf-export-dialog.component";
import 'rxjs/Rx';
import * as moment from "moment";


import { GroupDialog } from './group/group.dialog';
import { ChartDialog } from './chart/chart.dialog';
import { EditDashboardDialog } from './editDashboard/edit-dashboard.dialog';
import { ReplaySubject } from "rxjs/Rx";
import { takeUntil } from "rxjs/operators";
import { AclService, DeviceService } from "../shared/services";

@Component({
  selector: "app-private-dashboard",
  templateUrl: "./private-dashboard.component.html",
  styleUrls: ["./private-dashboard.component.scss"],  
  encapsulation: ViewEncapsulation.None
})
export class PrivateDashboardComponent implements OnInit, OnDestroy {
  private _unsubscribeAll : ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  dashboardId: string;
  dashboardName: string;
  groupIds = [];
  groupList = [];
  groupTabs = [];
  widgetList = [];
  othersWidgetList = [];
  countsWidgetList = [];
  widgetListGroup = [];
  groupsForPlayList = [];
  siteList = [];
  zoneList = [];
  deviceList = [];
  isExpanded = 0;
  isPlaying = 0;
  _isPredictive: boolean = false;
  _indexDatabase: any;
  activeGroupIndex: number = 0;
  playlistTimeout = [];
  showChartEdit: boolean = false;
  showChartDelete: boolean = false;
  showChartExpand: boolean = false;
  actionsVisible: boolean = false;
  enableSortable: boolean = false;
  enableGhostResize: boolean = false;
  showGroupExport: boolean = false;
  LoopCounter = 0;
  widgetIdsImges = [];
  resizeEdgeSetting = { bottom: false, right: true, top: false, left: false };
  resizeEdgeMapSetting = { bottom: true, right: true, top: false, left: false };

  //all the ids with enable status will be considered in group export
  groupExportWidgets: any = {};
  exportTypeN = "";
  userExportPer: any;
  groupOption = {};
  maxGroupId = 1;
  // jsPDF: any; // Important
  constructor(
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private dashboardService: DashboardService,
    public router: Router,
    private groupService: GroupService,
    private widgetService: WidgetService,
    private playlistService: PlaylistService,
    private commonService: CommonService,
    private userService: UserService,
    private siteService: SiteService,
    private zoneService: ZoneService,
    private brandService: BrandService,
    private deviceService: DeviceService,
    private aclService: AclService
  ) {
  }

  ngOnInit() {
    this.commonService.connectIdxDB().then(dbConn => {
      this._indexDatabase = dbConn;      
    });
    this.queryParamEvent();
    this.BindSiteAndZones();   
    this.componentEvent();
    this.getSegmentsList();
    this.BindAllGeoSites();
    this.getWidgetWidth();   
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }
  
  queryParamEvent() {
    this.activatedRoute.queryParams.pipe(takeUntil(this._unsubscribeAll)).subscribe((params: Params) => {
      this.isPlaying = parseInt(params.play);
      if (this.isPlaying) {
        document.documentElement.className += " toggle-expanded";
      }
    });
    this.groupList = [];
    this.activatedRoute.params.pipe(takeUntil(this._unsubscribeAll)).subscribe((params: Params) => { 
      this.dashboardId = params["id"];
      this.dashboardName = params["name"];
      this.groupIds = [];
      this.groupList = [];
      this.setGroupList(this.dashboardId);
    });
  }

  componentEvent() {
    this.dashboardService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(data => {
      if (["updateName"].includes(data.action)) {
        this.dashboardName = data.data;
      }
    });

    this.groupService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(data => {
      if (["createGroup", "updateGroup", "deleteGroup"].includes(data.action)) {      
        this.setGroupList(this.dashboardId, 1);        
      }
    });
    this.widgetService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(data => {
      if (["createWidget", "updateWidget", "deleteWidget", "refreshCharts", "updateG", "updateGeoConfigModal"].includes(data.action)) {
        
        let groupId = data.data.groupId;
        if (data.action == "updateGeoConfigModal") {
          groupId = data.data.groupId;
          this.commonService.deleteIdxWidgetData(this._indexDatabase, data.data.widgetId);
          this.dialog.closeAll();
        }
        else {
          if (this.widgetListGroup[groupId] && this.widgetListGroup[groupId].length > 0) {
            if(this._indexDatabase.objectStoreNames.length > 0){
              var _widgetKeys = this.widgetListGroup[groupId].map((w) => { return w._id });
              this.commonService.deleteIdxWidgetData(this._indexDatabase, _widgetKeys);
            }
          }
        }
        let groups = [];
        this.groupList.forEach((v, i) => {
          if (v._id == groupId) {
            groups.push(v);
          }
        });
        this.getWidgetList(groups, this.dashboardId, 1);        
        if (this.widgetListGroup && this.widgetListGroup.length > 0) {
          let isPivotTable = this.widgetListGroup[groupId].find(a => a.fetchDataFor == 'table' && a._id == data.data.widgetId);
          if (isPivotTable) {
            if (this.groupOption && this.groupOption[groupId] && this.groupOption[groupId].showChartEdit) {
              data.showPv = true;
              this.commonService.sendAction("showDesignerPivot", data);              
            }
          }
        }
      }

      if (["reApplyGroupFilter"].includes(data.action)) {
        if (this.widgetListGroup[data.data.groupId] && this.widgetListGroup[data.data.groupId].length > 0) {
          if(this._indexDatabase.objectStoreNames.length > 0){
            var _widgetKeys = this.widgetListGroup[data.data.groupId].map((w) => { return w._id });
            this.commonService.deleteIdxWidgetData(this._indexDatabase, _widgetKeys);
          }
        }
        let filter = data.data;
        this.groupList = this.groupList.map(g => {
          if (g._id == filter.groupId) {
            g.filterFor = filter.filterFor;
            g.sites = filter.sites;
            g.mappedFullSite = filter.mappedFullSite;
            g.zones = filter.zones;
            g.brands = filter.brands;

            g.showDataByOperationalHours = filter.showDataByOperationalHours;

            g.dateType = filter.dateType;
            g.from = filter.from;
            g.to = filter.to;
            g.groupByTimeFrame = filter.groupByTimeFrame;
            g.showSpecificDate = filter.showSpecificDate;
            g.consolidateSiteData = filter.consolidateSiteData;
            g.consolidateData = filter.consolidateData;
            g.consolidateDate = filter.consolidateDate||0;
            g.refreshGroup = filter.refreshGroup;
            g.trendFrom = filter.trendFrom;
            g.showTrend = filter.showTrend;
            g.showSelection = filter.showSelection;
            g.countryId = filter.countryId;
            g.devices = filter.devices;
          }
          return g;
        });
        this.recalculateGroupSelectionList(this.groupList.filter(x => x._id == filter.groupId));
        let groups = [];
        this.groupList.forEach((v, i) => {
          groups.push(v);
        });        
        this.getWidgetList(groups, this.dashboardId, 1);
      }
    });

    //get User ExportPermission
    let userP = this.userService.getLoggedInUser();
    this.userExportPer = userP.settings;
  }

  // dashboardInEditMode() {
  //   this.showChartEdit = !this.showChartEdit;
  //   this.showChartDelete = !this.showChartDelete;
  //   this.showChartExpand = !this.showChartExpand;
  //   this.actionsVisible = !this.actionsVisible;
  //   this.enableSortable = !this.enableSortable;
  //   this.enableGhostResize = !this.enableGhostResize;

  //   if (this.showChartEdit) {
  //     this.commonService.sendAction("showDesignerPivot", true);
  //   } else {
  //     this.commonService.sendAction("showDesignerPivot", false);
  //   }
  //   this.commonService.sendAction("redesignTableComponent", "");
  // }
  dashboardInEditMode(grpId) {
    if (grpId) {
      let isDashboardAccess = this.aclService.checkModuleAccess('private-dashboard:write');
      this.groupOption[grpId].showChartEdit = !this.groupOption[grpId].showChartEdit;
      this.groupOption[grpId].showChartDelete = !this.groupOption[grpId].showChartDelete;
      this.groupOption[grpId].showChartExpand = !this.groupOption[grpId].showChartExpand;
      this.groupOption[grpId].showGroupExport = !this.groupOption[grpId].showGroupExport;
      this.groupOption[grpId].actionsVisible = !this.groupOption[grpId].actionsVisible;
      this.groupOption[grpId].enableSortable = !this.groupOption[grpId].enableSortable ? isDashboardAccess : !this.groupOption[grpId].enableSortable;
      this.groupOption[grpId].enableGhostResize = !this.groupOption[grpId].enableGhostResize ? isDashboardAccess : !this.groupOption[grpId].enableGhostResize;

      let data = { showPv: false, gId: grpId };

      if (this.groupOption[grpId].showChartEdit) {
        data.showPv = true;
        this.commonService.sendAction("showDesignerPivot", data);
      } else {
        this.commonService.sendAction("showDesignerPivot", data);
      }
      // data.showPv = true;
      this.commonService.sendAction("redesignTableComponent", data);
    }
  }

  showGroupExportF(grpId) {
    this.groupOption[grpId].showGroupExport = !this.groupOption[grpId].showGroupExport;
  }

  expandToggleGroup(isExpanded) {
    if (isExpanded) {
      document.documentElement.className += " toggle-expanded";
    } else {
      document.documentElement.className = document.documentElement.className.replace(' toggle-expanded', '');
    }
    this.isExpanded = isExpanded;
  }

  //iscu = is group create/update
  setGroupList(dashboardId, iscu = 0) {
    // return;
    this.groupService.list(dashboardId).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        res.forEach(group => {
          if (group.hasOwnProperty('showSelection') && group.showSelection) {
            if (group.mappedFullSite == 1) {
              if (group.sites.includes('full')) {
                let sites = this.siteList.map(x => { return x.siteName }).join(', ');
                if (sites)
                  group["selectionList"] = "<span class='sectionstart'>Selected Sites: </span><span>" + sites + "</span>";
              }
              else {
                let sites = this.siteList.filter(x => group.sites.includes(x._id)).map(x => { return x.siteName }).join(', ');
                if (sites)
                  group["selectionList"] = "<span class='sectionstart'>Selected Sites: </span><span>" + sites + "</span>";
              }
            }else if(group.mappedFullSite == 2){
              if (group.devices.length > 0) {
                let _allDevice = [...group.devices];
                _allDevice = _allDevice.map(x => { return x.indexOf('|') && x.split('|')[1] });
                let devices = this.deviceList.filter(x => _allDevice.includes(x._id)).map(x => { return x.siteName + '::' + x.deviceName }).join(', ');
                if (devices)
                  group["selectionList"] = "<span class='sectionstart'>Selected Devices: </span><span>" + devices + "</span>";
              }
            }
            else {
              if (group.zones.length > 0) {
                let _allZones = [...group.zones];
                _allZones = _allZones.map(x => { return x.indexOf('|') && x.split('|')[1] });
                let zones = this.zoneList.filter(x => _allZones.includes(x._id)).map(x => { return x.siteName + '::' + x.zoneName }).join(', ');
                if (zones)
                  group["selectionList"] = "<span class='sectionstart'>Selected Zones: </span><span>" + zones + "</span>";
              }
            }
          }
        });
        //this.groupList = res;
        let g = res.filter(g => !g.isSection);
        let s = res.filter(s => s.isSection);

        res = [...g, ...s];

        this.groupsForPlayList = Object.assign([], res);
        this.maxGroupId = res && res.length > 0 ? res[res.length - 1].order : this.maxGroupId || this.maxGroupId;
        //load widgets     
        this.getWidgetList(res, dashboardId);

        if (iscu == 0) {
          this.getPlayList();
        }
      }
    );
  }
  getOperationHours(dateType, fromDate, toDate, sites) {
    if (!fromDate) {
      fromDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      fromDate = this.commonService.getDateConverted(fromDate, "YYYY-MM-DD HH:mm:ss");
    }
    if (!toDate) {
      toDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      toDate = this.commonService.getDateConverted(toDate, "YYYY-MM-DD HH:mm:ss");
    }

    if (!['Custom'].includes(dateType)) {
      let dateObj = this.commonService.convertDate(dateType, fromDate, toDate);
      fromDate = dateObj.firstDay;
      toDate = dateObj.lastDay;
    }

    if (!sites)
      sites = ["full"];
    let requst = {
      from: fromDate,
      to: toDate,
      sites: sites
    }
    return this.siteService.getOperationHr(requst);
  }
  // generateCanvasImg(ObjData)
  // {
  //   html2canvas(ObjData)
  //   .then(function (canvas) {
  //   // Few necessary setting options
  //   var imgWidth = 600;
  //   var pageHeight = 600;
  //   var imgHeight = canvas.height * imgWidth / canvas.width;
  //   var heightLeft = imgHeight;

  //   // const contentDataURL = canvas.toDataURL('image/png')

  //     canvas.toBlob(function(blob) {
  //       var newImg = document.createElement('img'),
  //           url = URL.createObjectURL(blob);

  //       newImg.onload = function() {
  //         // no longer need to read the blob so it's revoked
  //         URL.revokeObjectURL(url);
  //       };
  //       newImg.src = url;
  //       console.log("i :" ,newImg.src)
  //       // getWidgetIdsData[i].blobUrl  =  newImg.src;
  //       // this.widgetListGroup[this.groupIds[this.activeGroupIndex]][i].blobUrl= newImg.src;
  //     });

  //   })
  // }

  generatePDF(LoopCount) {
    let groupListTemp = this.groupList;
    this.getSiteName((sRes) => {
      groupListTemp[this.activeGroupIndex]["sitesRes"] = sRes;
      this.getZoneName((zRes) => {
        groupListTemp[this.activeGroupIndex]["zonesRes"] = zRes;
        this.getBrandName((bRes) => {
          groupListTemp[this.activeGroupIndex]["brandsRes"] = bRes;
          this.openPDFViewver(groupListTemp);
        });
      });
    });
  }

  openPDFViewver(groupListTemp) {
    //filter widgets not in showGroupExport
    let filteredWigetList = {};
    let index = this.groupIds[this.activeGroupIndex];
    filteredWigetList[index] = [];
    this.widgetListGroup[index].forEach(w => {
      if (this.groupExportWidgets[w._id] == true) {
        filteredWigetList[index].push(w);
      }
    });
    if (filteredWigetList[index].length == 0 || this.showGroupExport == false) {
      filteredWigetList[index] = this.widgetListGroup[index];
    }
    this.showGroupExport = false;

    this.dialog.open(PdfViewerDialog, {
      data: {
        widgetListGroup: filteredWigetList,
        groupIds: this.groupIds,
        activeGroupIndex: this.activeGroupIndex,
        dashboardName: this.dashboardName,
        groupList: groupListTemp
      },
      height: "auto",
      width: "1000px",
      panelClass: "export-modal"
    });
  }


  openExportDashboard() {
    // console.log(this.groupList);
    this.dialog.open(ExportDashboardViewerDialog, {
      data: {
        groupListGroup: this.groupList, dashboardId: this.dashboardId, dashboardName: this.dashboardName,
        userExportPer: this.userExportPer
      },
      height: "auto",
      width: "800px",
      panelClass: "dasboard-export-modal"
    });
  }

  openScheduleDashboard() {
    // console.log(this.groupList);
    this.dialog.open(ScheduleDashboardViewerDialog, {
      data: {
        groupListGroup: this.groupList, dashboardId: this.dashboardId, dashboardName: this.dashboardName,
        userExportPer: this.userExportPer
      },
      height: "auto",
      width: "800px",
      panelClass: "dasboard-export-modal"
    });
  }

  getSiteName(cb) {
    let sitesId = this.groupList[this.activeGroupIndex].sites;
    let filter = "fields=siteName";
    if (sitesId && sitesId.length > 0) {
      if (sitesId[0] != "full")
        sitesId.forEach((siteId, i) => {
          filter += "&where[_id][]=" + siteId;
        });
      this.siteService.list(filter).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        cb(res)
      });
    }
    else {
      cb([]);
    }
  }

  getZoneName(cb) {
    let zonesId = this.groupList[this.activeGroupIndex].zones;
    let filter = "fields=zoneName";
    if (zonesId && zonesId.length > 0) {
      if (zonesId[0] != "full")
        zonesId.forEach((zoneId) => {
          filter += "&where[_id][]=" + zoneId;
        });
      this.zoneService.list(filter).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        cb(res);
      });
    }
    else {
      cb([]);
    }
  }


  getBrandName(cb) {
    let brandId = this.groupList[this.activeGroupIndex].brands;
    let filter = "fields=brandName";
    if (brandId && brandId.length > 0) {
      if (brandId[0] != "full")
        brandId.forEach((brandId) => {
          filter += "&where[_id][]=" + brandId;
        });
      this.brandService.list(filter).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        cb(res);
      })
    }
    else {
      cb([]);
    }
  }


  //to load widget forcefully pass load as 1
  getWidgetList(groups, dashboardId, load = 0) {
    let loop = (group, dashboardId) => {
      let groupId = group._id;

      this.getOperationHours(group.dateType, group.from, group.to, group.sites).pipe(takeUntil(this._unsubscribeAll)).subscribe((hRes) => {
        if (hRes) {
          group["operationHours"] = hRes;
        }
      });


      if (this.groupIds.includes(groupId) && load == 0) {
        this.groupList.forEach((v, i) => {
          if (v && v._id == group._id) {
            this.groupList[i].groupName = group.groupName;
            this.groupList[i].order = group.order;
            this.groupList[i].isSection = group.isSection;
            this.groupList[i].isGeo = group.isGeo;
            this.groupList[i].isPredictive = group.isPredictive;
            this.groupList[i].parentId = group.parentId;
            this.groupList[i]._id = group._id;
          }
        })

        if (groups.length > 0) {
          loop(groups.shift(), dashboardId);
        }
        this.orderGroup();
        return false;
      }


      this.widgetService.list(groupId, dashboardId).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.widgetListGroup[groupId] = res;
          if (load == 0) {
            this.groupList.push(group);
          }
          if (!this.groupIds.includes(group._id)) {
            this.groupIds.push(group._id);
          }
          if (groups.length > 0) {
            loop(groups.shift(), dashboardId);
          } else {
            this.orderGroup();
            this.groupOptions();
          }
        },
        err => { }
      );
    };


    if (groups.length > 0) {
      loop(groups.shift(), dashboardId);
    }
  }

  listOrderChanged(groupId) {
    let widgetOrder = [];
    this.widgetListGroup[groupId].forEach((w, i) => {
      widgetOrder.push({ widgetId: w._id, order: i + 1 });
    });

    this.widgetService.widgetOrder(widgetOrder).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      //do not do any thing next time
      //it will fetch according to order
    });
  }

  onResizeEnd(e: ResizeEvent, widget, grpId) {
    if (!this.groupOption[grpId].enableGhostResize) {
      return;
    }
    let el = document.getElementById(widget._id);
    if (widget.fetchDataFor == 'geomap') {
      el.parentNode["style"]["maxHeight"] = e.rectangle.height + "px";
    }
    let increasedWidth = e.rectangle.width;
    let increasedHeight = e.rectangle.height;
    let parentWidth = el.parentNode.parentNode["clientWidth"];

    //width percentage
    let width = (increasedWidth * 100) / parentWidth;
    width = width > 100 ? 100 : width;

    //round to multiple of 5
    width = Math.ceil(width / 5) * 5;
    el.parentNode["style"]["flex"] = "0 0 " + width + "%";
    el.parentNode["style"]["maxWidth"] = width + "%";
    el.parentNode["style"]["minWidth"] = width + "%";

    //hit resize event
    setTimeout(() => {
      var resizeEvent = window
        .document
        .createEvent('UIEvents');
      resizeEvent.initEvent('resize', true, false);
      window.dispatchEvent(resizeEvent);
    }, 100);

    //save in db
    let resizeWidget: any = {};
    if (widget.fetchDataFor == 'geomap') {
      resizeWidget = {
        widgetId: widget._id,
        width: width,
        height: increasedHeight
      };
    }
    else {
      resizeWidget = {
        widgetId: widget._id,
        width: width
      };
    }
    this.widgetService.widgetResize(resizeWidget).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.widgetListGroup[grpId] = this.widgetListGroup[grpId].filter((w) => {
        return w._id == widget._id ? w.widgetConfig.width = width : w;
      })
      if (widget.fetchDataFor == 'geomap') {
        let objData = {
          height: increasedHeight,
          widgetId: widget._id
        }
        this.groupService.sendAction("reSizeMapHeight", objData);
      }
      else if (widget.fetchDataFor == 'table') {
        this.commonService.sendAction("showResizeTablePivot", '');
      }
    });
  }

  applyWidgetWidth(widget, defaultSize) {
    return (
      widget.widgetConfig && widget.widgetConfig.width > 0
        ? widget.widgetConfig.width
        : defaultSize);
  }

  applyWidgetHeight(widget) {
    if (widget.fetchDataFor == 'geomap' && widget.widgetConfig.height) {
      return widget.widgetConfig.height + 'px';
    }
  }

  orderGroup = () => {
    this.groupList.sort(function (a, b) {
      if (a.order > b.order) {
        return 1;
      } else if (a.order < b.order) {
        return -1;
      }
      return 0;
    });

    let g = this.groupList.filter(g => !g.isSection);
    let s = this.groupList.filter(s => s.isSection);

    //tab was behaving weird so putting all section at the end
    this.groupList = [...g, ...s];
  }

  reloadAllGroupData(group) {
    this.widgetService.sendAction("refreshCharts", { groupId: group });
  }

  groupOptions() {
    // this.groupOption = {};
    this.groupList.forEach((v, i) => {
      if (!this.groupOption || !this.groupOption[v._id]) {
        let options = { showChartEdit: false, showChartDelete: false, showChartExpand: false, showGroupExport: false, enableSortable: false, enableGhostResize: false, actionsVisible: false };
        this.groupOption[v._id] = options;
      }
    });
  }

  openGroupDialog = (group: any = {}, isEdit = false) => {
    let data: any = {};
    if (!group) {
      data.dashboardId = this.dashboardId;
      data.groupId = "";
      data.groupName = "";
      data.parentId = "";
      data.groupList = this.groupList;
    } else {
      let tempGroupList = this.groupList;
      if (isEdit) {
        let activeId = this.groupList[this.activeGroupIndex]._id;
        tempGroupList = this.groupList.filter(ob => ob._id != activeId);
        tempGroupList = tempGroupList && tempGroupList.length == 0 ? this.groupList : tempGroupList;
      }
      data.dashboardId = this.dashboardId;
      data.groupId = group._id;
      data.groupName = group.groupName;
      data.order = group.order;
      data.isPredictive = group.isPredictive;
      data.isSection = group.isSection;
      // this._isPredictive=group.isPredictive;     
      data.parentId = group.parentId;
      data.groupList = tempGroupList;
      data.demoGraphicOption = this.userExportPer.geoData == "1" ? true : false;
      data.isGeo = group.isGeo;
    }

    data.allowPA = (this.userExportPer.predictiveAnalytics == 1 ? true : false);
    data.maxGroupId = this.maxGroupId;

    this.dialog.open(GroupDialog, {
      data: data,
      height: "auto",
      width: "400px",
      panelClass: "full-modal"
    });
  };

  openChartDialog = (widget: any = {}) => {
    this.dialog.open(ChartDialog, {
      data: {
        dashboardId: this.dashboardId,
        groupList: this.groupList,
        widgetData: widget,
        groupId: this.groupIds[this.activeGroupIndex]
      },
      height: "auto",
      width: "800px",
      panelClass: "full-modal"
    });
  };

  editDashboardDialog = () => {
    this.dialog.open(EditDashboardDialog, {
      data: {
        dashboardId: this.dashboardId,
        dashboardName: this.dashboardName
      },
      height: "auto",
      width: "400px",
      minHeight: "200px",
      panelClass: "full-modal"
    });
  };

  deleteGroup(did, gid) {
    if (confirm("Are you sure you want to remove this group?") == false) {
      return false;
    }

    let temp = this.groupList;
    this.groupList = this.groupList.filter(item => item["_id"] !== gid);
    this.groupService.delete(did, gid).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        if (this.groupList && this.groupList.length > 0)
          this.groupService.sendAction("deleteGroup", this.groupList[(this.groupList.length == 1 ? 0 : this.activeGroupIndex)]._id);
      },
      err => {
        this.groupList = temp;
      }
    );
  }

  deleteWidget(widgetID, isS) {
    if (
      confirm(
        "Are you sure you want to delete this Chart & all of its contents present in it ?"
      ) == false
    ) {
      return false;
    }
    this.widgetService.delete(widgetID).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.commonService.deleteIdxWidgetData(this._indexDatabase, widgetID);
        this.widgetService.sendAction("deleteWidget", { groupId: this.groupList[this.activeGroupIndex]._id, widgetId: widgetID });
        if (isS)
          location.reload();
      },
      err => {
        this.widgetList = widgetID;
      }
    );
  }

  delete(dashboardId) {
    if (
      confirm(
        "Are you sure you want to delete this Dashboard & all of its contents present in it ?"
      ) == false
    ) {
      return false;
    }

    this.dashboardService.delete(dashboardId).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.router.navigate(["/dashboard"]);

        //save dashboard details
        if (this.userService.getLoggedInUser().defaultDashboard == dashboardId) {
          let data = { defaultDashboard: "", defaultDashboardName: "" };
          this.userService.savePersonalDetailsToToken(data);
        }


        this.dashboardService.sendAction("deleteDashboard", "");
      },
      err => { }
    );
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    // console.log(tabChangeEvent);
    if (tabChangeEvent.index < 0) {
      return;
    }
    let selectedTabName = tabChangeEvent.tab.textLabel;
    let selectedTabId = "";
    this.groupList.forEach((v, i) => {
      if (v.groupName == selectedTabName) {
        selectedTabId = v._id;
        this._isPredictive = v.isPredictiveSearch;
        this.activeGroupIndex = i;
      }
    });
    // console.log(selectedTabId);
    // this.widgetService.sendAction("refreshCharts", selectedTabId);
    this.groupService.sendAction("closeFilter", "");
  }

  public openGroupFilter(group) {
    this.groupService.sendAction("openFilter", group);
  }

  public async retrainModel() {
    if (confirm("Retraining model takes considerable time, Are you sure you want to do it anyway?") == false) {
      return false;
    }
    this.commonService.openSnackBar('Mode training started', '');
    $('.retrain span').addClass('fa-spin');
    setTimeout(() => {
      $('.retrain span').removeClass('fa-spin');
    }, 20 * 1000);
    await this.userService.requestRetrain();
  }

  public openExportFilter(isScheduled, grpId) {
    let actionN = isScheduled ? "openScheduledMail" : "openMail";
    let mailExport = {};
    mailExport["dashboardName"] = this.dashboardName;
    mailExport["dashboardId"] = this.dashboardId;
    mailExport["groupIds"] = grpId;//this.groupIds[this.activeGroupIndex];
    this.groupService.sendAction(actionN, mailExport);
  }

  getGroupDate(group) {
    let g = Object.assign({}, group);
    // if (g.dateType != "Custom") {
    //,'MTD','YTD','WTD'
    if (!['Custom'].includes(g.dateType)) {
      if (g.to == "") {
        g.to = new Date();
      }
      let dateObj = this.commonService.convertDate(g.dateType, g.from, g.to);
      g.from = dateObj.firstDay;
      g.to = dateObj.lastDay;
    }

    //set first data and last day to show on front end
    // console.log("From :",g.from," to: ",g.to)
    // let firstDay = this.commonService.getUTCToLocalDate(new Date(g.from), 1); //1 is for formatted date
    // let lastDay = this.commonService.getUTCToLocalDate(new Date(g.to), 1);

    //ripun
    let firstDay = this.commonService.getDateConverted(g.from, "DD-MMM-YYYY");
    let lastDay = this.commonService.getDateConverted(g.to, "DD-MMM-YYYY");
    // let firstDay = this.commonService.getDateConverted(g.from, "DD-MMM-YYYY");
    // let lastDay = this.commonService.getDateConverted(g.to, "DD-MMM-YYYY");   
    if (window.navigator.maxTouchPoints || 'ontouchstart' in window.document.documentElement)
      return firstDay + " - " + lastDay + "";
    else
      return "<span class='sectionstart'>Date Range: </span>" + firstDay + " - " + lastDay + "";
  }


  getTrendDate(group) {
    let firstDay = "";
    if (group.showTrend) {
      let tempD = this.commonService.getDateConverted(group.trendFrom, "DD-MMM-YYYY");
      firstDay += `<span class='sectionstart'>Trend Date: </span>${tempD}`;
    }
    return firstDay;
  }

  /*************************** PLAYLIST START *******************************/

  getPlayList() {
    this.activatedRoute.queryParams.pipe(takeUntil(this._unsubscribeAll)).subscribe((params: Params) => {
      if (params.play == 1) {
        this.playingList(params.playlist, params.play, params.playIndex);
      }
    });
  }

  playingList(id, isPlaying, playIndex) {
    if (isPlaying) {
      this.isPlaying = 1;
      document.documentElement.className += " toggle-expanded";
    }
    let playListData = JSON.parse(localStorage.getItem('playlist'));
    if (playListData == null && isPlaying == 1) {
      // let _this2 = this;
      this.playlistService.list("where[_id]=" + id).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        playListData = res;
        localStorage.setItem('playlist', JSON.stringify(res));
        this.playTheList(playListData, isPlaying, playIndex);
      });
    } else {
      this.playTheList(playListData, isPlaying, playIndex);
    }
  }

  playTheList(playListData, isPlaying, playIndex) {
    if (isPlaying == 1) {
      let playIndexes = playIndex.split("-");
      this.activeGroup(playIndexes);
      let t = setTimeout(() => {
        let dashboardIndex = parseInt(playIndexes[0]);
        let groupIndex = parseInt(playIndexes[1]) + 1;
        let generatedUrl = { url: "", qParams: {} };
        if (playListData[0].mapped[dashboardIndex].groups[groupIndex] && playListData[0].mapped[dashboardIndex].groups[groupIndex].groupId) {
          generatedUrl = this.generatePlaylistUrl(playListData, dashboardIndex, groupIndex);
        } else {
          dashboardIndex++;
          groupIndex = 0;
          generatedUrl = this.generatePlaylistUrl(playListData, dashboardIndex, groupIndex);
        }

        this.isExpanded = 0;
        // console.log(generatedUrl);
        this.router.navigate([generatedUrl.url], { queryParams: generatedUrl.qParams });
      }, playListData[0].interval);
      this.playlistTimeout.push(t);
    }
  }

  generatePlaylistUrl(playListData, dashboardIndex, groupIndex) {
    let url = "";
    let qParams = {};
    document.documentElement.className = document.documentElement.className.replace(' toggle-expanded', '');
    if (playListData[0].mapped.length != dashboardIndex) {
      url += 'private-dashboard/' + playListData[0].mapped[dashboardIndex].dashboardName;
      url += '/' + playListData[0].mapped[dashboardIndex].dashboardId;
      qParams = {
        playlist: playListData[0]._id,
        play: '1',
        playIndex: dashboardIndex + '-' + groupIndex
      };
      return { url: url, qParams: qParams };
    } else {
      localStorage.removeItem('playlist');
      // this.isExpanded = 0;
      // this.isPlaying = 0;
      return { url: 'play-list', qParams: {} };
    }
  }

  activeGroup(playIndexes) {
    let playlistData = JSON.parse(localStorage.getItem('playlist'));
    let groupId = playlistData[0].mapped[playIndexes[0]].groups[playIndexes[1]].groupId;
    // console.log(groupId);
    // console.log(this.groupList);
    this.groupsForPlayList.forEach((v, i) => {
      if (groupId == v._id) {
        setTimeout(() => {
          this.activeGroupIndex = i;
          this.isExpanded = 1;
        }, 500)
        // console.log(i);
      }
    });
  }

  stopPlaylist() {
    this.isPlaying = 0;
    document.documentElement.className = document.documentElement.className.replace(' toggle-expanded', '');
    this.router.navigate(['play-list']);
    localStorage.removeItem('playlist');
    this.playlistTimeout.forEach(plt => {
      clearTimeout(plt);
    });
  }

  // kpiResponse(response): void {
  //   // console.log("Api response : ", response);
  //   if (response) {
  //     //Find current group widget id and append Api response to it.
  //     var kpiList = this.widgetListGroup[this.groupIds[this.activeGroupIndex]].find(o => o._id == response.widgetId)
  //     if (kpiList) {
  //       this.widgetListGroup[this.groupIds[this.activeGroupIndex]].find(o => o._id == response.widgetId)["response"] = response.Response;
  //     }
  //   }
  // }

  // siteResponse(responses): void {
  //   if (responses) {
  //     var kpiList = this.widgetListGroup[this.groupIds[this.activeGroupIndex]].find(o => o._id == responses.widgetId)
  //     if (kpiList) {
  //       var checkResponseFeildP = this.widgetListGroup[this.groupIds[this.activeGroupIndex]].find(o => o._id == responses.widgetId)["response"];
  //       if (checkResponseFeildP != {}) {
  //         this.widgetListGroup[this.groupIds[this.activeGroupIndex]].find(o => o._id == responses.widgetId)["response"]
  //           = { sites: responses.response };
  //       }
  //       else {
  //         this.widgetListGroup[this.groupIds[this.activeGroupIndex]].find(o => o._id == responses.widgetId)["response"]["sites"] = responses.response;
  //       }
  //     }
  //   }
  // }



  /*************************** PLAYLIST END *******************************/

  updateExportGroup(e) {
    if (!this.groupExportWidgets[e.widgetId]) {
      this.groupExportWidgets[e.widgetId] = false;
    }
    this.groupExportWidgets[e.widgetId] = e.allowInGroupExport;
  }

  exportDocument(exportType, grpId) {
    let index = grpId;//this.groupIds[this.activeGroupIndex];
    //environment.baseUrl +
    this.exportTypeN = exportType;
    let url = "export/dashboard/" + this.dashboardId + "/" + exportType + "?groups=" + index + "&widgets=";
    if (this.groupOption[grpId].showGroupExport == true) {
      this.widgetListGroup[index].forEach(w => {
        if (this.groupExportWidgets[w._id] == true) {
          url += w._id + ",";
        }
      });

      this.groupOption[grpId].showGroupExport = false;
    }
    if (exportType == "pdf") {
      this.dialog.open(PdfViewerDialog, {
        data: { url: url, exportType: exportType, dashboardName: this.dashboardName },
        height: "auto",
        width: "1000px",
        panelClass: "export-modal"
      });
    }
    else {
      this.dialog.open(ExportGroupViewerDialog, {
        data: { url: url, exportTypeN: this.exportTypeN, dashboardName: this.dashboardName },
        height: "auto",
        width: "500px",
        panelClass: "group-export-modal"
      });
    }
  }

  getSegmentsList() {
    this.groupService.getGeoSegments().pipe(takeUntil(this._unsubscribeAll)).subscribe(r => {
      if (localStorage.getItem("getSegsdsxcmt") == "" || localStorage.getItem("getSegsdsxcmt") == undefined || localStorage.getItem("getSegsdsxcmt") == null)
        localStorage.setItem("getSegsdsxcmt", btoa(JSON.stringify(r)));
    });
  }


  BindAllGeoSites() {
    this.siteService.listGeoSites().pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        if (localStorage.getItem("getSitesdsxcmt") == "" || localStorage.getItem("getSitesdsxcmt") == undefined || localStorage.getItem("getSitesdsxcmt") == null)
          localStorage.setItem("getSitesdsxcmt", btoa(JSON.stringify(res)));
      });
  }

  getWidgetWidth() {
    if (localStorage.getItem("widgetWidthdsxcmt") == "" || localStorage.getItem("widgetWidthdsxcmt") == undefined || localStorage.getItem("widgetWidthdsxcmt") == null) {
      this.widgetService.getWidgetDefaultWidth().pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          res = res && res[0];
          localStorage.setItem("widgetWidthdsxcmt", btoa(JSON.stringify(res)));
        });
    }
  }

  BindSiteAndZones() {
    this.siteService.list("fields=siteName").pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.siteList = res;
    });
    this.zoneService.list("fields=zoneName,siteId").pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.zoneList = res;
    });
    this.deviceService.getDeviceList().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.deviceList = res;
    });
  }

  recalculateGroupSelectionList(group) {
    if (group.length > 0)
      group = group[0];
    if (group.hasOwnProperty('showSelection') && group.showSelection) {
      if (group.mappedFullSite == 1) {
        if (group.sites.includes('full')) {
          let sites = this.siteList.map(x => { return x.siteName }).join(', ');
          if (sites)
            group["selectionList"] = "<span class='sectionstart'>Selected Sites: </span><span>" + sites + "</span>";
        }
        else {
          let sites = this.siteList.filter(x => group.sites.includes(x._id)).map(x => { return x.siteName }).join(', ');
          if (sites)
            group["selectionList"] = "<span class='sectionstart'>Selected Sites: </span><span>" + sites + "</span>";
        }
      }else if(group.mappedFullSite == 2){
        if (group.devices.length > 0) {
          let _allDevice = [...group.devices];
          _allDevice = _allDevice.map(x => { return x.indexOf('|') && x.split('|')[1] });
          let devices = this.deviceList.filter(x => _allDevice.includes(x._id)).map(x => { return x.siteName + '::' + x.deviceName }).join(', ');
          if (devices)
            group["selectionList"] = "<span class='sectionstart'>Selected Devices: </span><span>" + devices + "</span>";
        }
      }
      else {
        if (group.zones.length > 0) {
          let _allZones = [...group.zones];
          _allZones = _allZones.map(x => { return x.indexOf('|') && x.split('|')[1] });
          let zones = this.zoneList.filter(x => _allZones.includes(x._id)).map(x => { return x.siteName + '::' + x.zoneName }).join(', ');
          if (zones)
            group["selectionList"] = "<span class='sectionstart'>Selected Zones: </span><span>" + zones + "</span>";
        }
      }
    }
    else {
      delete group["selectionList"];
    }
  }
}




// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/private-dashboard/private-dashboard.component.ts